import { render, staticRenderFns } from "./StagingAreaPage.vue?vue&type=template&id=02c80050"
import script from "./StagingAreaPage.vue?vue&type=script&lang=ts"
export * from "./StagingAreaPage.vue?vue&type=script&lang=ts"
import style0 from "./StagingAreaPage.vue?vue&type=style&index=0&id=02c80050&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports